// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__CqA4b","consentsList":"PatientConsents_consentsList__27Moc","consentsListEmpty":"PatientConsents_consentsListEmpty__xaV-g"};